import { useMemo } from "react";
import ConstantFunctions from "../constants_functions";

export const useBrandConfig = () => {
  const constantFunctions = useMemo(() => new ConstantFunctions(), []);

  return useMemo(
    () => ({
      brandName: constantFunctions.getBrandName(),
      isPaysonic: constantFunctions.isPaysonic(),
      // Helper methods
      getBrandName: () => constantFunctions.getBrandName(),
      getIsPaysonic: () => constantFunctions.isPaysonic(),
    }),
    [constantFunctions]
  );
};

export default useBrandConfig;
